import { render, staticRenderFns } from "./SubmitNewResume.vue?vue&type=template&id=5347ef46&scoped=true&"
import script from "./SubmitNewResume.vue?vue&type=script&lang=js&"
export * from "./SubmitNewResume.vue?vue&type=script&lang=js&"
import style0 from "./SubmitNewResume.vue?vue&type=style&index=0&id=5347ef46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347ef46",
  null
  
)

export default component.exports